/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import React, { Fragment, Component } from 'react';
import Store from 'state/Store';

import DeleteCustomGroup from './DeleteCustomGroupModal';
import CreateCustomAccountsGroup from 'components/layouts/Preferences/CustomizeAccountsView/CreateCustomAccountsGroupModal';
import BaseModal from 'components/shared/Modal/BaseModal';
import {
  setCustomAccount,
  refreshCustomAccountGroups
} from 'state/preferences/PreferencesActions';
import { AAMBeaconButton } from 'components/shared/Beacon';

class ViewCustomAccountsGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      action: '',
      accountSelectorModalOpen: false,
      deleteModalOpen: false
    };
  }

  handleModalClose = () => {
    this.setState(
      { accountSelectorModalOpen: false, deleteModalOpen: false },
      () => {
        Store.dispatch(refreshCustomAccountGroups());
      }
    );
  };

  handleModalOpen = (id) => {
    const group = this.props.customGroups[id];
    Store.dispatch(setCustomAccount(group.groupId));
    this.setState({ accountSelectorModalOpen: true });
  };

  openDeleteModal = (id) => {
    const group = this.props.customGroups[id];
    Store.dispatch(setCustomAccount(group.groupId));
    this.setState({ deleteModalOpen: true });
  };

  render() {
    const { customGroups } = this.props;
    const { accountSelectorModalOpen, deleteModalOpen } = this.state;
    return (
      <Fragment>
        <table className="table-component">
          <thead>
            <tr className="custom-group-titles">
              <th>Name</th>
              <th>Number of Accounts</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {customGroups.map((group, index) => {
              const { groupName, accountDescriptors } = group;
              return (
                <tr key={index}>
                  <td className="group-name">{groupName}</td>
                  <td className="group-accounts">
                    {accountDescriptors.length}
                  </td>
                  <td className="group-action-box">
                    <AAMBeaconButton
                      variant="primary"
                      onBeaconEventClick={() => this.handleModalOpen(index)}
                    >
                        Edit
                    </AAMBeaconButton>
                    <AAMBeaconButton
                      variant="tertiary"
                      onBeaconEventClick={() => this.openDeleteModal(index)}
                    >
                        Delete
                    </AAMBeaconButton>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <BaseModal
          close={this.handleModalClose}
          hideAnchor={true}
          hideClose={true}
          isOpen={accountSelectorModalOpen}
          label="account-selection-modal"
          title={'Edit Custom Account Group'}
          className="customize-accounts-modal"
        >
          <CreateCustomAccountsGroup close={this.handleModalClose} />
        </BaseModal>
        <BaseModal
          close={this.handleModalClose}
          hideAnchor={true}
          hideClose={true}
          isOpen={deleteModalOpen}
          label="account-selection-modal"
          title={'Delete Custom Account Group'}
          className="customize-accounts-delete-modal"
        >
          <DeleteCustomGroup close={this.handleModalClose} />
        </BaseModal>
      </Fragment>
    );
  }
}

export default ViewCustomAccountsGroup;
